import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "@data/services/modules/auth/auth.service";
import {resolveLandingRoute} from "@data/constants/role-landing-route.constant";

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser = this.authService.getUser;
    if (currentUser) {
      // Usuario ya autenticado intentando entrar a una ruta pública (/login):
      // lo mandamos a su landing route por rol en lugar de a '/' fijo, que
      // bloquearía a Seller/Broker/Legal porque ya no tienen dashboard.view.
      const route = resolveLandingRoute(currentUser.user?.permissions?.name);
      //! Rol sin destino privado (Client, o uno nuevo aún sin mapear): su landing ES
      //! '/login'. Redirigir ahí estando ya ahí no hace nada —el router ignora la
      //! navegación a la misma URL— y el `return false` cancelaba la actual, dejando la
      //! pantalla en blanco sin siquiera poder ver el formulario para salir. Se cierra la
      //! sesión (no abre ninguna ruta de este panel) para que el login se pinte limpio y
      //! no envuelto en el layout autenticado.
      if (route === '/login') {
        this.authService.logout();
        return true;
      }
      this.router.navigate([route]);
      return false;
    }
    // not logged in, so redirect to login page with the return url
    return true;
  }
}
